import axios from "api/client";

// The signed-in student's own review of a class.
export default {
  mine: (courseId) => axios.get("/reviews/mine", { params: { course_id: courseId } }).then((res) => res.data),
  create: (courseId, rating, note) => axios.post("/reviews", { course_id: Number(courseId), rating, ...(note ? { note } : {}) }).then((res) => res.data),
  update: (id, rating, note) => axios.put(`/reviews/${id}`, { rating, note: note || "" }).then((res) => res.data),
};
